import type { CSSProperties, FC } from "react";
import type { IComponentBaseProps } from "@/shared/config";
import { useCN } from "@/shared/lib/hooks";
import type { ICases } from "../config";

/**
 * Блок Use Cases / карточки для ролей
 * @param heading Заголовок блока
 * @param items Массив карточек с иконкой и описанием
 */

/**
 *
 */
export const Cases: FC<ICases & IComponentBaseProps> = ({
  baseClass = "cases",
  heading,
  items,
}) => {
  const { getCN } = useCN(baseClass);
  const headingCentered = {
    "--heading-line-height": "1",
    "--heading-margin-desktop": "0",
    "--heading-margin-tablet": "0",
    "--heading-margin-mobile": "0",
  } as CSSProperties;

  return (
    <section className={getCN("", {}, [ "bg-white" ])}>
      <div className={`${getCN("wrap")} flex items-center w-full flex-col gap-11 mobile:gap-6`}>
        <h2 style={headingCentered} className={"text-center text-primary"}>
          {heading}
        </h2>
        <div className={getCN("grid", {}, [ "grid grid-cols-[repeat(3,minmax(15rem,37rem))] mobile:grid-cols-[repeat(2,minmax(19rem,35rem))] justify-between tablet:justify-center mobile:justify-center gap-4 mobile:gap-6 leading-[.9] w-full" ])}>

          {items.map((item, index) => (
            <div
              key={index}
              className={"flex flex-col items-start gap-6 mobile:gap-3 bg-gray-50 p-5 mobile:p-0 box-content rounded-xl hover:shadow-md transition-shadow w-[37rem] mobile:w-[32rem] max-w-full h-auto aspect-[264/164]"}
            >
              <img draggable={false} src={item.iconSrc} alt={typeof item.title === "string" ? item.title : "icon"} className={"w-12 h-12"} />
              <div className={"flex flex-col gap-3 mobile:gap-1"}>

                <h6 className={"h6 text-primary pb-2 tracking-[-0.035em] font-semibold"}>{item.title}</h6>
                <p className={"description"}>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
